import { Controller } from '@hotwired/stimulus'

export default class ChangeRequestController extends Controller {
  static targets = ['timezone', 'time']

  connect() {
    if (this.timezoneTarget && !this.timezoneTarget.querySelector('option[selected]')) {
      this.timezoneTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone
    }

    if (this.timeTarget && !this.timeTarget.value) {
      const pad = (val) => val.toString().padStart(2, '0')

      const now = new Date()
      const year = now.getFullYear()
      const month = pad(now.getMonth() + 1)
      const day = pad(now.getDate())
      const hours = pad(now.getHours())
      const minutes = pad(now.getMinutes())

      // format required for "datetime-local" inputs:
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Guides/Date_and_time_formats#local_date_and_time_strings
      this.timeTarget.value = `${year}-${month}-${day}T${hours}:${minutes}`
    }
  }
}
